import { IDropdown } from '../types/dropdown.interface';

export const filtersMainColors: IDropdown[] = [
  { value: 'RED', label: 'enums.colors.RED' },
  { value: 'GREEN', label: 'enums.colors.GREEN' },
  { value: 'BLUE', label: 'enums.colors.BLUE' },
  { value: 'BROWN', label: 'enums.colors.BROWN' },
  { value: 'BLACK', label: 'enums.colors.BLACK' },
  { value: 'ORANGE', label: 'enums.colors.ORANGE' },
  { value: 'WHITE', label: 'enums.colors.WHITE' },
  { value: 'PURPLE', label: 'enums.colors.PURPLE' },
  { value: 'GRAY', label: 'enums.colors.GRAY' },
  { value: 'BEIGE', label: 'enums.colors.BEIGE' },
  { value: 'GOLD', label: 'enums.colors.GOLD' },
  { value: 'SILVER', label: 'enums.colors.SILVER' },
  { value: 'IVORY', label: 'enums.colors.IVORY' },
  { value: 'CREAM', label: 'enums.colors.CREAM' },
  { value: 'YELLOW', label: 'enums.colors.YELLOW' },
];

export const filtersStoneGrades: IDropdown[] = [
  { value: 'A', label: 'enums.grades.A' },
  { value: 'A_PLUS', label: 'enums.grades.A_PLUS' },
  { value: 'B', label: 'enums.grades.B' },
  { value: 'B_PLUS', label: 'enums.grades.B_PLUS' },
  { value: 'C', label: 'enums.grades.C' },
  { value: 'N', label: 'enums.grades.N' },
];

export const filtersSurfaceFinishing: IDropdown[] = [
  { value: 'POLISHED', label: 'enums.stoneSurfaceFinishing.POLISHED' },
];
